<template>
  <div class="form-group last">
    <fieldset>
      <div class="form-input-column">
        <ValidationProvider
          v-slot="{ errors }"
          class="form-input-column"
          name="Contact Phone"
          rules="numeric"
        >
          <input
            id="nocPhone"
            v-model="updateCellPhone"
            type="text"
            class="form-control"
            placeholder=" "
            pattern=".*\d"
            :disabled="formData.disabled"
          >
          <label
            id="labelCellPhone"
            for="nocPhone"
            class="mt-5"
          >
            Peering/NOC contact Phone
          </label>
          <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>

        <ValidationProvider
          v-slot="{ errors }"
          class="form-input-column"
          name="Contact Email"
          rules="required|email"
        >
          <small
            id="nocEmail"
            class="form-text text-muted"
          >(Validation email will be sent to this address)</small>
          <input
            id="nocEmail"
            v-model="updateContactMail"
            type="email"
            class="form-control"
            placeholder=" "
            :disabled="formData.disabled"
          >
          <label
            id="labelnocEmail"
            for="nocEmail"
          >
            Peering/NOC contact Email*
          </label>
          <span class="error">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="form-row align-items-center mb-5">
        <div class="col-md-6">
          <div :disabled="formData.disabled">
            <span>maximum prefixes required</span>
          </div>
        </div>

        <div class="col-md-3 form-input-column-ip">
          <input
            id="prefixesIP4"
            v-model="updatePrefixIPv4"
            type="number"
            min="0"
            class="form-control"
            placeholder="0"
            :disabled="formData.disabled"
          >
          <label
            id="labelIP4"
            for="prefixesIP4"
            class="mt-5"
          >for IPv4</label>
        </div>
        <div class="col-md-3 form-input-column-ip">
          <input
            id="prefixesIP6"
            v-model="updatePrefixIPv6"
            type="number"
            min="0"
            class="form-control"
            placeholder="0"
            :disabled="formData.disabled"
          >
          <label
            id="labelIP6"
            for="prefixesIP6"
            class="mt-5"
          >for IPv6</label>
        </div>
      </div>
    </fieldset>
    <div class="from-row form-textarea">
      <fieldset>
        <div class="form-input-column">
          <textarea
            id="info"
            v-model="updateMessage"
            class="form-control"
            placeholder="Additional info"
            rows="4"
            :disabled="formData.disabled"
          />
          <label
            id="infoMessage"
            for="info"
            class="textareaLabel"
          >Additional info</label>
        </div>
      </fieldset>
    </div>
  </div>
</template>


<script>
import VueRecaptcha from "vue-recaptcha";
import * as label from "./script/label.js";

import {
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";

export default {
  name: "ContactFieldset",
  components: {
    ValidationProvider
  },
  computed: {
    formData() {
      return this.$store.state.formData;
    },
    networkDetails() {
      return this.$store.state.networkDetails;
    },
    updateCellPhone: {
      get() {
        return this.$store.state.formData.contactPhone;
      },
      set(value) {
        this.$store.commit("setFormDataContactPhone", value);
        label.labelChangeClass("labelCellPhone", value);
      }
    },

    updateContactMail: {
      get() {
        return this.$store.state.formData.contactMail;
      },
      set(value) {
        this.$store.commit("setFormDataContactMail", value);
        label.labelChangeClass("labelnocEmail", value);
      }
    },

    updatePrefixIPv4: {
      get() {
        return this.$store.state.formData.prefixIPv4;
      },
      set(value) {
        this.$store.commit("setFormDataPrefixIPv4", value);
        label.labelChangeClass("labelIP4", value);
      }
    },

    updatePrefixIPv6: {
      get() {
        return this.$store.state.formData.prefixIPv6;
      },
      set(value) {
        this.$store.commit("setFormDataPrefixIPv6", value);
        label.labelChangeClass("labelIP6", value);
      }
    },

    updateMessage: {
      get() {
        return this.$store.state.formData.message;
      },
      set(value) {
        this.$store.commit("setFormDataMessage", value);
        label.labelTextareaChangeClass("infoMessage", value);
      }
    }
  }
};
</script>

<style lang="scss">
@import "/less/anx-button.less";
@import "/less/anx-checkbox.less";
@import "/less/anx-peering-form.less";

</style>
